 import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import styles from "./thumbnailSlider.module.css";
import { HeadingTitle, Image, SubHeadingTitle } from "../../shared/index";
import { getImageUrl } from "../../../lib/get-image";
import { LiaRupeeSignSolid } from "react-icons/lia";
const ThumbnailSlider = ({ bannersData }) => {
  return (
    <Swiper
      spaceBetween={10}
      slidesPerView={1}
      centeredSlides={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      pagination={{ clickable: true }}
      lazy={true}
      modules={[Autoplay, Pagination, Navigation]}
      className={styles.mainslider}
    >
      {bannersData?.map((item, index) => {
        const bannerJson = item?.json ? JSON.parse(item.json) : item;
        return (
          <SwiperSlide key={index}>
            <div className={styles.slide__container}>
              <Image
                src={getImageUrl(bannerJson?.image_url)}
                alt={bannerJson?.banner_title}
                className={styles.slide_image}
              />
              <div className={styles.bannerText}>
                {/* <HeadingTitle
                  text={bannerJson?.banner_title}
                  style={styles.bannerHeading}
                /> */}
                {/* <SubHeadingTitle
                  subTitle={bannerJson?.banner_content}
                  style={styles.banner__paragraph}
                /> */}
                {/* <span className={styles.price}>
                  Starting at  <LiaRupeeSignSolid size={20} />{bannerJson?.starting_price}
                </span> */}
              </div>
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
};
export default ThumbnailSlider;